module.exports = __webpack_public_path__ + "img/logo-detartrage-blanc.23800c97.svg";